import React, { Component } from "react";
import { setRoom, addChat, broadcastAnd } from "../redux/actions";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideo, faClosedCaptioning } from "@fortawesome/free-solid-svg-icons";

class UnconnectedVideoURLForm extends Component {

	constructor(props) {
		super(props);
		this.state = { video_url:this.props.video_url, subtitle_url: this.props.subtitle_url };
	}

    handleChange(event) {    
        let change = { [event.target.name] : event.target.value };
		this.setState(change);  
    }

    showS3Warning() {
        return this.state.video_url.includes("https://s3.console.aws");
    }

    showFacebookWarning() {
        return this.state.video_url.includes("https://l.messenger.com/");
    }

    // According to https://reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#recommendation-fully-controlled-component, this
    // is an antipattern, but it's actually what we want here - your draft should be deleted if the room "moves" to a new video. 
    componentDidUpdate(prevProps) {
        if (prevProps.video_url !== this.props.video_url) {
            this.setState({
                video_url: this.props.video_url
            });
        }
        if (prevProps.subtitle_url !== this.props.subtitle_url) {
            this.setState({
                subtitle_url: this.props.subtitle_url
            });
        }
    }

    async saveUrls(event) {
        event.preventDefault();

        let finalVideoUrl = await this.processUrl(this.state.video_url);
        let finalSubtitleUrl = await this.processUrl(this.state.subtitle_url);

		this.props.broadcastAnd({ 
				nick_name: this.props.nick_name,
                room_key: this.props.room_key,
                namespace: "control",
				action: setRoom({ video_url: finalVideoUrl, subtitle_url: finalSubtitleUrl, video_position:0, video_position_timestamp:0, video_length:0, is_playing:false, password: this.props.password })
			}
        );
        
        let msg = "[Loaded '" + this.state.video_url + "']";
        this.props.broadcastAnd({
            nick_name: this.props.nick_name,
            room_key: this.props.room_key,
            namespace: "chat",
            action: addChat(this.props.nick_name,msg)
        });
    }
    

        /* Mangle the url if needed, ultimately returning a video file */
        async processUrl(url) {
            let regexp = new RegExp("^https://app.put.io/a-gift-from/(.*)/(.*)","i");
            var results = regexp.exec(url);
            if (results && results[2]) {
                return await this.getPutIOVideoUrl(results[2]);
            } else {
                return url;
            }
        }
    
        async getPutIOVideoUrl(token) {
            // console.log("Fetching from put.io token ",token);
            let url = "https://api.put.io/v2/files/public?codecs_parent=1&media_info_parent=1&mp4_status_parent=1&mp4_stream_url_parent=1&oauth_token=" + token + "&stream_url_parent=1&video_metadata_parent=1";
            // console.log("Trying to fetch",url);
            // eslint-disable-next-line no-undef
            let response = await fetch(url);
            let json = await response.json();
            // console.log("Got ",json);
            return json.parent.stream_url;
        }



    render() {
        return (
            <form onSubmit={this.saveUrls.bind(this)}>
                <div className="field is-horizontal">
                    <div className="field-label is-normal">
                        <label className="label">Video URL</label>
                    </div>
                    <div className="field-body">
                        <div className="field">
                            <div className="control has-icons-left is-expanded">
                                <input className="input" type="text" placeholder="" name="video_url" value={this.state.video_url} onChange={this.handleChange.bind(this)}/>
                                <span className="icon is-small is-left">
                                    <FontAwesomeIcon icon={faVideo} size="lg" fixedWidth/> 
                                </span>
                            </div>
                            {this.showS3Warning() ? <p className="notification is-danger">This looks like an S3 console URL, not the public link. It might not work for other people. Instead, on the S3 page, click Make Public, then look for the Object Url near the bottom of the page.</p> : ""}
                            {this.showFacebookWarning() ?  <p className="notification is-danger">This looks like Facebook Messenger has mangled the link. Try opening it yourself, then copying the "real" (not facebook) link from the browser address bar. </p> : ""}
                            <p className="help">Enter a full URL of a video file, beginning https://. Make sure that you have the rights to this file, and that it's in a format that browsers can handle. (Use something like Handbrake to re-encode if needed). For example: http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4 </p>
                            <p className="help">PutIO "share this with a friend" URLs are supported, but the file must be playable in a browser without transcoding (not all are).</p>
                            <p className="help">Youtube URLs also work, but you may get ads, and if you click any of Youtube's controls or suggested videos you'll go out of sync.</p>
                        </div>
                    </div>
                </div>
                <div className="field is-horizontal">
                    <div className="field-label is-normal">
                        <label className="label">Subtitle URL (optional)</label>
                    </div>
                    <div className="field-body">
                        <div className="field">
                            <div className="control has-icons-left is-expanded">
                                <input className="input" type="text" placeholder="" name="subtitle_url" value={this.state.subtitle_url} onChange={this.handleChange.bind(this)}/>
                                <span className="icon is-small is-left">
                                    <FontAwesomeIcon icon={faClosedCaptioning} size="lg" fixedWidth/> 
                                </span>
                            </div>
                            <p className="help">Enter a full URL of a VTT file, beginning https://. If needed you can <a href="https://gotranscript.com/subtitle-converter">convert SRT files to VTT format</a>. </p>
                        </div>
                    </div>
                </div>
                <div className="field is-horizontal">
                    <div className="field-label is-normal">
                        <label className="label"></label>
                    </div>
                    <div className="field-body">
                        <div className="field">
                            <div className="control">
                                <input type="submit" className="button  is-dark" value="Set"></input>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => ({ 
    video_url: state.room.video_url,
    subtitle_url: state.room.subtitle_url,
    password: state.room.password,
    room_key: state.user.room_key,
    nick_name: state.user.nick_name
});
export const VideoURLForm = connect(mapStateToProps, { broadcastAnd })(UnconnectedVideoURLForm);
